import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { KeyValue } from '@angular/common';

@Injectable()
export class RewardService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getRewards(): Observable<KeyValue<string, number>> {
    return this.get(`reward`);
  }

  public getRewardsPerOrder(id: number): Observable<KeyValue<string, number>> {
    return this.get(`reward/${id}`);
  }
}
